import React from "react";
import { PropTypes } from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Grid from "@mui/material/Grid";
// Limitless imports
import { createSuggestions } from "../../../../utils/AutoCompleteDataUtil";
import DropdownMenu from "@limitless/modern/inputs/dropdown-menu/DropdownMenu";
import { useTranslation } from "@limitless/common/hooks";
import IconButton from "@limitless/modern/inputs/icon-button/IconButton";
import RefreshIcon from "@limitless/icons/RefreshIcon";
import { useExpertMessageContext } from "../../../../../expert";
import AiReasoningStarIcon from "../ai-reasoning-star-icon/AiReasoningStarIcon";
const CategoriseByResponseCode = ({
  classes,
  action,
  isMandatory,
  message,
  messageResources,
  value,
  onValueChange,
  isReadOnly,
  aiReviewData
}) => {
  var _aiReviewData$respond, _aiReviewData$respond4;
  const {
    t
  } = useTranslation();
  const messageContext = useExpertMessageContext();
  const {
    fetchReasonCodes,
    responseCodeError,
    isButtonVisible
  } = messageContext;
  const responseCodeSuggestions = React.useMemo(() => {
    return createSuggestions(messageResources.reasonCodes.codes[action.reasonCodeKey], {
      labelDataKey: "description",
      valueDataKey: "code",
      includeItemObject: true
    });
  }, [messageResources]);
  const [hasUserSelected, setHasUserSelected] = React.useState(false);
  const isAIGeneratedResponseCode = React.useMemo(() => message.aiSubject ? message.responseCode === message.aiSubject : false, [message.responseCode, message.aiSubject]);
  const aiResponseCodeReasoning = aiReviewData === null || aiReviewData === void 0 ? void 0 : (_aiReviewData$respond = aiReviewData.respondResponseCode) === null || _aiReviewData$respond === void 0 ? void 0 : _aiReviewData$respond.reasoning;
  const selectedValue = React.useMemo(() => {
    var _aiReviewData$respond2;
    const responseCode = aiReviewData === null || aiReviewData === void 0 ? void 0 : (_aiReviewData$respond2 = aiReviewData.respondResponseCode) === null || _aiReviewData$respond2 === void 0 ? void 0 : _aiReviewData$respond2.responseCode;
    const matched = responseCodeSuggestions.find(option => option.value === responseCode);
    return matched !== null && matched !== void 0 && matched.label ? {
      ...matched,
      label: t(matched.label)
    } : null;
  }, [responseCodeSuggestions, aiReviewData]);
  const getDropdownValue = () => {
    if (hasUserSelected) {
      return value.label ? {
        ...value,
        label: t(value.label)
      } : null;
    }
    if (aiResponseCodeReasoning) {
      return selectedValue;
    }
    return value.label ? {
      ...value,
      label: t(value.label)
    } : null;
  };
  React.useEffect(() => {
    var _aiReviewData$respond3;
    if (aiReviewData !== null && aiReviewData !== void 0 && (_aiReviewData$respond3 = aiReviewData.respondResponseCode) !== null && _aiReviewData$respond3 !== void 0 && _aiReviewData$respond3.responseCode && selectedValue) {
      onValueChange({
        [action.payloadKey]: {
          ...selectedValue,
          isStepComplete: true,
          doLiveUpdate: true
        }
      });
    }
  }, [aiReviewData === null || aiReviewData === void 0 ? void 0 : (_aiReviewData$respond4 = aiReviewData.respondResponseCode) === null || _aiReviewData$respond4 === void 0 ? void 0 : _aiReviewData$respond4.responseCode, selectedValue]);
  return /*#__PURE__*/React.createElement(Grid, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.subContainer
  }, /*#__PURE__*/React.createElement(DropdownMenu, {
    label: aiResponseCodeReasoning ? /*#__PURE__*/React.createElement(React.Fragment, null, "Response Code", /*#__PURE__*/React.createElement(AiReasoningStarIcon, {
      title: aiReviewData.respondResponseCode.reasoning
    })) : `Response Code${isAIGeneratedResponseCode ? " (Suggested by AI)" : ""}`,
    required: isMandatory,
    value: getDropdownValue(),
    id: action.id,
    fullWidth: true,
    options: responseCodeSuggestions,
    placeholder: "Please select a response code",
    onChange: (e, selected) => {
      setHasUserSelected(true);
      onValueChange({
        [action.payloadKey]: {
          ...selected,
          isStepComplete: true,
          doLiveUpdate: true
        }
      });
    },
    textFieldProps: {
      error: responseCodeError !== "",
      helperText: responseCodeError
    },
    disabled: isReadOnly
  })), isButtonVisible && /*#__PURE__*/React.createElement(IconButton, {
    icon: /*#__PURE__*/React.createElement(RefreshIcon, null),
    className: classes.icon,
    label: "Refetch Code",
    onClick: () => fetchReasonCodes(message, messageResources)
  }));
};
const styles = {
  subContainer: {
    width: "100%"
  },
  icon: {
    marginLeft: "5px"
  }
};
export default withStyles(styles)(CategoriseByResponseCode);
CategoriseByResponseCode.propTypes = {
  action: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired,
  messageResources: PropTypes.object.isRequired,
  onValueChange: PropTypes.func.isRequired,
  value: PropTypes.object,
  isMandatory: PropTypes.bool.isRequired,
  isReadOnly: PropTypes.bool,
  aiReviewData: PropTypes.object
};